import * as React from 'react'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import { NextActionDate } from '@user/components/EntityCards/atoms/NextActionDate/NextActionDate'
import type { ILeadDetail } from '@user/store/lead'
import { ExpectedClosingDate } from '@user/components/EntityCards/atoms/ExpectedClosingDate'
import type { IOpportunityDetail } from '@user/store/opportunity'
import { ENTITY_TYPES } from '@sales-center/common'
import { useDialogState } from '@user/utils/useDialogState'
import { AttachmentsButton } from '@user/components/Leads/LeadCard/LeadAttachmentsDrawer/AttachmentIconButton'
import { EntityAttachmentsDrawer } from '@user/features/EntityDetails/components/EntityAttachmentsDrawer'
import { ActivitiesManager } from '@user/features/Activity'

interface Props {
  detail: ILeadDetail | IOpportunityDetail
  canUpdate: boolean
  canDelete: boolean
  canConvert: boolean
}

export function EntityDatesPanel(props: Props) {
  const { detail, canUpdate } = props
  const { id, nextActionDate, assignee, salesTeamId } = detail

  const [attachmentsDrawerOpen, showAttachmentsDrawer, hideAttachmentsDrawer] =
    useDialogState()

  const attachmentsState = {
    onOpenAttachments: showAttachmentsDrawer,
    onCloseAttachments: hideAttachmentsDrawer,
    attachmentsOpen: attachmentsDrawerOpen,
  }

  const isOpportunity = detail.entityType === ENTITY_TYPES.Opportunity

  return (
    <Paper>
      <Stack
        px={2}
        py={1}
        direction="row"
        spacing={1}
        alignItems="center"
        justifyContent="start"
      >
        <NextActionDate
          disabled={!canUpdate}
          id={id}
          nextActionDate={nextActionDate}
          entity={detail.entityType}
        />
        {isOpportunity && (
          <ExpectedClosingDate
            id={detail.id}
            disabled={!canUpdate}
            expectedClosingDate={
              (detail as IOpportunityDetail).expectedClosingDate
            }
          />
        )}
        <AttachmentsButton {...attachmentsState} />
        <ActivitiesManager
          entityId={id}
          entityType={detail.entityType}
          salesTeamId={salesTeamId}
          ownerId={assignee?.id || null}
        />
      </Stack>

      <EntityAttachmentsDrawer
        entityType={detail.entityType}
        entityId={detail.id}
        canUpdate={canUpdate}
        {...attachmentsState}
      />
    </Paper>
  )
}
